import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { creator, errorMessageGenerator } from 'uwork-app-core';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/workers/orders/confirm/resend/REQUEST';
export const SUCCESS = '@app/workers/orders/confirm/resend/SUCCESS';
export const FAILURE = '@app/workers/orders/confirm/resend/FAILURE';
export const CLEAR = '@app/workers/orders/confirm/resend/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    error: '',
    success: false
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.success = true;
                draft.loading = false;
                break;
            case FAILURE:
                draft.error = payload;
                draft.loading = false;
                break;
            case REQUEST:
                draft.loading = true;
                draft.success = false;
                draft.error = '';
                break;
            case CLEAR:
                draft.loading = false;
                draft.success = false;
                draft.error = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: () => creator(SUCCESS),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            yield axios.get(`/orders/resend-order-confirmation/${payload}`);
            yield put(actions.success());
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
